import React, { Component } from 'react';

class SafeHTML extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  createMarkup = () => {
    const { html } = this.props;
    return { __html: html };
  };

  render() {
    return (
      <>
        <div dangerouslySetInnerHTML={this.createMarkup()} />
      </>
    );
  }
}

export default SafeHTML;
